exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "[save-button][data-v-613920de]{display:block;margin-left:auto}.pointer[data-v-613920de]{cursor:pointer}.link-like[data-v-613920de]{text-decoration:underline!important}.file-name[data-v-613920de]{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-613920de","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/os/Invoice.vue
// module id = 1020
// module chunks = 0